import { useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { chevronForwardOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface } from '../data/item';
import React, { Component }  from 'react';
import '../pages/Main.css'; 

  
const ContentMini : React.FC<ContentInterface> = ({ content }) => {
    
    const router = useIonRouter();

    // retrieve the content type
    const ContentType = () : string => {
        if (content.type == "image")
            return "image post";
        if (content.type == "vidfile" || content.type == "video")
            return "video post";
        if (content.type == "text")
            return "paragraph post";
        // else
        return "N-social post";
    }

    // when click on post
    const clickPost = () => {
        router.push("/content/" + content.id + "/n", "forward", "push");
    }

    return (
        <IonItem className="mini-content" lines="none" onClick={clickPost}>
            <IonThumbnail slot="start">
                <img src={ content.thumbnail != "" ? content.thumbnail : content.user_avatar } />
            </IonThumbnail>
            
            <IonLabel>
                <div className="cm-title">{ content.title != "" ? content.title : content.user_name }</div>
                <IonNote className="cm-desc ion-text-wrap">{ content.desc != "" ? content.desc : ContentType() }</IonNote>
            </IonLabel>
        </IonItem>
    );
};
  
export default ContentMini;